
export const isEmail = (text: string) => {
  const emailRegex = /^\S+@\S+\.\S+$/;
  return emailRegex.test(text);
};

// format date time to local string with month/day/year hour:minute, or without time if excludeTime is true
export const formatDateTime = (value: string | number | Date, excludeTime = false) => {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return '';
  
  if (excludeTime) {
    return date.toLocaleDateString([], {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
    });
  }
  
  // Format date and time separately to ensure seconds are excluded
  const dateStr = date.toLocaleDateString([], {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
  });
  const timeStr = date.toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  
  return `${dateStr} ${timeStr}`;
};

export const toDateInputValue = (value: string | number | Date) => {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return '';
  return new Date(value).toISOString().slice(0, 10);
};

export const enumToOptions = (enumObj: any): { key: string | number, value: string }[] => Object.keys(enumObj)
  .filter(k => isNaN(Number(k)))
  .map((k) => ({
    key: k.replaceAll('_', ' '),
    value: enumObj[k],
  }));

